import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { CareElementFrequencyType } from "@/Flowsheets/Models/CareElementFrequencyType";
import { CareElementFrequencySubLabel } from "./CareElementFrequencySubLabel";

import styles from "./CareElementWithFrequencyLabel.module.scss";

interface ICareElementWithFrequencyLabelProps {
    label: string | JSX.Element;
    keyName: string
    state: { Frequency?: CareElementFrequencyType; LastReviewedDate?: Date | null; DateReviewedWithPrecision?: DateTimeWithPrecision | null };
    encounterDate: Date;
}
/**
 * CareElementWithFrequencyLabel component for rendering a care element label with frequency information.
 * @param props - The props for the component.
 * @property {string} props.label - The label for the care element.
 * @property {string} props.keyName - The key name for the care element.
 * @property {object} props.state - The state of the care element.
 * @property {Date} props.encounterDate - The encounter date for the care element.
 * @returns The rendered component.
 */
export function CareElementWithFrequencyLabel({
    label,
    keyName,
    state,
    encounterDate
}: Readonly<ICareElementWithFrequencyLabelProps>): JSX.Element {
    return (
        <div className={styles.container}>
            <label className={styles.careElementLabel}>{label}</label>
            <CareElementFrequencySubLabel
                id={`selfManagementPlan-frequency-${keyName}`}
                frequency={state.Frequency}
                encounterDate={encounterDate}
                dataCy={`selfManagementPlan-frequency-${keyName}`}
                dateReviewed={(() => {
                    const dateReviewed = state.DateReviewedWithPrecision?.value ? new Date(state.DateReviewedWithPrecision.value) : null;
                    const lastReviewedDate = state.LastReviewedDate ? new Date(state.LastReviewedDate) : null;

                    if (!dateReviewed)
                        return lastReviewedDate;

                    if (!lastReviewedDate)
                        return dateReviewed;

                    return dateReviewed > lastReviewedDate ? dateReviewed : lastReviewedDate;
                })()}
            />
        </div>
    );
}
